<template>
    <div>
      <router-view />
    </div>
  </template>
  <script>
  
  export default {
    name: "WaMessageAccess",
    data () {
      return {}
    },
    created () {
  
    },
    methods: {
    
    },
  }
  
  </script>
  